import { createAction, props } from '@ngrx/store';

import { BackendResponse } from 'src/app/core/interfaces/shared.interface';
import { UserInDetail, UsersParams } from '../users.interface';

export const setUsers = createAction(
  '[Users Component] Set Users',
  props<{ users: BackendResponse<UserInDetail>; params: UsersParams; pageNumber: number }>()
);

export const updateManyUsers = createAction(
  '[Users Component] Update many Users',
  props<{ users: { ids: string[]; changes: Partial<UserInDetail> } }>()
);

export const updateUsers = createAction('[Users Component] Update Users', props<{ users: UserInDetail[] }>());

export const updateUser = createAction('[Users Component] Update User', props<{ user: UserInDetail }>());

export const switchAdvancedOptions = createAction('[Users Component] Switch Advanced Options');

export const switchSelection = createAction('[Users Component] Switch Selection', props<{ id: string }>());

export const switchAllSelection = createAction('[Users Component] Switch All Selection', props<{ checked: boolean }>());

// Requests
export const loadUsers = createAction('[Api/Request Users] Load Users', (params: UsersParams, pageNumber: number = 1) => ({
  params,
  pageNumber
}));

export const changeUsersCustomerStatus = createAction(
  '[Api/Request] Change Users Customer Status',
  props<{ payload: { ids: string[]; customer_status: UserInDetail['customer_status'] } }>()
);
